

export function getQueryParam (query, name) {
  let obj = parseQuery(query)
  return obj[name]
}

export function setQueryParam (query, param, value) {
  let obj = parseQuery(query)
  if (value == null) {
    delete obj[param]
    return getQueryString(obj)
  }
  obj[param] = value
  return getQueryString(obj)
}

export function parseQuery (str) {
  if (typeof str != 'string' || str.length === 0) return {}
  let s = str.split('&')
  let s_length = s.length
  let bit, query = {}, first, second
  for (let i = 0; i < s_length; i++) {
    bit = s[i].split('=')
    first = decodeURIComponent(bit[0])
    if (first.length === 0) continue
    second = decodeURIComponent(bit[1])
    if (typeof query[first] == 'undefined') query[first] = second
    else if (query[first] instanceof Array) query[first].push(second)
    else query[first] = [query[first], second]
  }
  return query
}

export function getQueryString (obj) {
  let query = ''
  let keys = Object.keys(obj)
  for (let  i = 0; i < keys.length; i++) {
    let key = keys[i]
    if (typeof key != 'string') {
      continue
    }
    if (query.length > 0) {
      query += '&'
    }
    query += key + '='
    let value = obj[key]
    if (Array.isArray(value)) {
      let  valueStr = ''
      for (let  j = 0; j < value.length; j ++) {
        if (valueStr.length > 0) {
          valueStr += '+'
        }
        valueStr += value[j]
      }
      query += valueStr
    } else {
      query += value
    }
  }
  return encodeURI(query)
}
